// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4367":"52be0c84","4603":"c2243094","6459":"c3e32453"}[chunkId] + ".chunk.css";
};